import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import mainImage from './image/works/work5MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import { MainImage } from './workDetailPage/WorkMainImage';
import BackButton from './components/BackButton';
import { WorkFullImage } from './workDetailPage/WorkFullImage';
import research1 from './image/works/work5research1.webp';
import research2 from './image/works/work5research2.webp';
import { Divider } from '@mui/material';
import { Wavedivider } from './components/Wavedivider';
import strategy from './image/works/work5strategy.webp';
import { WorkImage } from './workDetailPage/WorkImage';
import wireframe from './image/works/work5wireframe.webp';
import system from './image/works/work5system.webp';
import system2 from './image/works/work5system2.webp';
import NextItem from './components/NextItem';
import thumbnail2 from './image/workThumbnails/thumbnail2.webp';
import design1 from './image/works/work5design1.webp';
import design2 from './image/works/work5design2.webp';
import design3 from './image/works/work5design3.webp';
import design4 from './image/works/work5design4.webp';
import cover from './image/works/work5coverimage.webp';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';

//NewServiceDesign

function Work5(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'New Service Design - Lynkim',
      description: 'Designing an entirely new book-share platform for working people who want to develop compentency.',
      image: '/ogimage.png',
    });
    
    // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
    const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
    
    return (
      // <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
      <>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn '>
        <WorkTitle 
          title={'New Service Design'} 
          description={'Designing an entirely new book-share platform for working people who want to develop compentency.'} 
          team={'Bookcovery'} 
          role={'Service Planning, UXUI Design'} 
          period={'2020.01. - 2020.08.'}
          titleKo={'신규 서비스 디자인'}
          descriptionKo={'성장을 원하는 직장인을 위한 새로운 북-쉐어 플랫폼을 설계했습니다.'}
          teamKo={'북커버리(Bookcovery)'}
          roleKo={'서비스 기획, UXUI 디자인'}
        />
      </div>
      <MainImage image={mainImage}/>

      <WorkTextSection
        title='Overview'
        description={<div>“Bookcovery” is an online book-sharing platform designed to help people seeking growth find the books they need. This service is planned to address the challenges faced by the younger knowledge-driven demographic in finding essential books and informational resources, while also promoting book consumption.</div>}
        subDescription={'“Bookcovery”는 성장을 원하는 사람들이 필요한 책을 찾을 수 있도록 돕는 온라인 북 쉐어링 플랫폼입니다. 지식 기반의 젊은 층이 필요한 책과 정보를 찾기 어려운 문제를 해결하고, 동시에 책 소비를 촉진하기 위해 기획되었습니다.'}
      />
      <div style={{padding:'24px'}}/>
      <Wavedivider/>
      {/* <Divider/> */}
      <WorkTextSection
        title='User research'
        description={<div>We recruited approximately 40 beta testers in their 20s to 40s. These beta testers are professionals who study specialized knowledge through books, work in specialized fields, and write about their expertise. <br/> They expressed key needs for a sense of <b>"intellectual belonging" and the "continuous discovery of learning materials."</b></div>}
        subDescription={'20대부터 40대까지 약 40명의 베타 테스터를 모셨습니다. 이들은 책을 통해 전문 지식을 공부하고, 전문 분야에서 일하며, 자신의 전문성에 대해 글을 쓰는 분들이었습니다. <br/> 이들은 <b>“지적 소속감”</b>과 <b>“학습 자료의 지속적인 발견”</b>에 대한 핵심 니즈를 보였습니다.'}
      />
      <WorkFullImage image={research1}/>
      <WorkFullImage image={research2}/>
      <WorkTextSection
        title='Hooks Habituation Strategy'
        description='Based on user interviews, we categorized users by their key needs and developed core service features as well as strategies for activation and retention.'
        subDescription={'사용자 인터뷰를 바탕으로 핵심 니즈 기준으로 유저를 분류하고, 이에 맞춘 핵심 서비스 기능과 활성화/유지 전략을 수립했습니다.'}
      />
      <WorkImage image={strategy} isMaxheight={false} isbottomPadding={true}/>
      <div style={{background: 'linear-gradient(180deg, var(--color-bg-soft) 0%, var(--color-bg-mid) 100%)', paddingBottom:'40px'}}>
        <WorkTextSection title='Wireframe'/>
        <WorkFullImage image={wireframe} isBottomMargin={true} /> 
      </div>
      <WorkTextSection title='Design System'/>
      <WorkFullImage image={system}/>
      <WorkFullImage image={system2}/>
      <div style={{background: 'linear-gradient(180deg, var(--color-bg-soft) 0%, var(--color-bg-mid) 100%)'}}>
        <WorkTextSection title='UXUI Design' description='Since the experience of discovering books through browsing is most important, I designed a UX that encourages repetitive behavior.' subDescription={'브라우징을 통해 책을 발견하는 경험이 가장 중요하다고 판단하여, 반복적인 탐색을 유도하는 UX를 설계했습니다.'}/>      
        <WorkFullImage image={design1}/>
      </div>
      <WorkFullImage image={design2}/>
      <WorkFullImage image={design3}/>
      <div style={{backgroundColor:'var(--color-gray-mid-warm)'}}><WorkFullImage image={design4}/></div>
      <div style={{marginTop:'60px'}}><WorkFullImage image={cover} isMargin={true} isRoundedCorner={true} isBottomMargin={true}/></div>
      <BackButton/>
      <NextItem to='/Work2' thumbnail={thumbnail2} nextProjectTitle='First User Process Design'/>
      <div style={{ height: "400px" }} />
      </>
      // </ProtectedPage>
    )
}

export default Work5;
